(function() {
  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    // simple focus trap: focus first focusable element or dialog
    var focusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    (focusable || modal).focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKeydown);
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.benefits-modal.is-open');
      if (open) closeModal(open);
    }
  }

  document.addEventListener('click', function(e) {
    var openBtn = e.target.closest('[data-modal-open]');
    if (openBtn) {
      var id = openBtn.getAttribute('data-modal-open');
      if (id) {
        e.preventDefault(); // keep URL as fallback but open modal instead
        openModal(id);
      }
      return;
    }

    var closeBtn = e.target.closest('[data-modal-close]');
    if (closeBtn) {
      var modal = closeBtn.closest('.benefits-modal');
      closeModal(modal);
      return;
    }

    if (e.target.matches('.benefits-modal__overlay') || e.target.closest('.benefits-modal__overlay')) {
      var modal = e.target.closest('.benefits-modal');
      closeModal(modal);
    }
  });

})();
